import { BasketProviderController } from '@ori/basket-provider-lib';
import { ServiceUrlsProvider } from '@ori/configuration-manager';
import { EnvironmentProvider } from '@ori/environment';
import { TranslationsProvider } from '@ori/i18n';

import type { ClientAppConfig } from './types';

export const App = ({ currentLanguage, globalApiUrl, identityUrl, staticApiUrl, tenant }: ClientAppConfig) => (
  <ServiceUrlsProvider
    serviceUrls={{
      globalApiUrl,
      identityUrl,
      staticApiUrl,
    }}
  >
    <EnvironmentProvider tenant={tenant}>
      <TranslationsProvider
        defaultTranslationsWithNamespaces={{}}
        language={currentLanguage}
        translationsWithNamespaces={{}}
      >
        <BasketProviderController />
      </TranslationsProvider>
    </EnvironmentProvider>
  </ServiceUrlsProvider>
);
